import React from "react";
import { SubscriberColumnId } from "../SubscribersTable.types";
import {
  subscribersColumns,
  uncheckableColumns,
} from "../SubscribersTable.helpers";
import { ColumnsSettingsDialogProps } from "./ColumnsSettingsDialog";

export function useColumnsSettingsDialog(props: ColumnsSettingsDialogProps) {
  const {
    onApply,
    visibleColumns,
    customAttributeNames = [],
    visibleCustomAttributes = [],
  } = props;

  const [selected, setSelected] = React.useState(visibleColumns);
  const [selectedCustomAttrs, setSelectedCustomAttrs] = React.useState<
    string[]
  >(visibleCustomAttributes);

  const apply = () => onApply(selected, selectedCustomAttrs);

  const isSelected = (id: SubscriberColumnId) => selected.includes(id);
  const isDisabled = (id: SubscriberColumnId) =>
    uncheckableColumns.includes(id);
  const isCustomAttrSelected = (name: string) =>
    selectedCustomAttrs.includes(name);

  const selectColumn = (id: SubscriberColumnId, checked: boolean) =>
    setSelected((prev) =>
      checked ? [...prev, id] : prev.filter((i) => i !== id)
    );

  const selectCustomAttr = (name: string, checked: boolean) =>
    setSelectedCustomAttrs((prev) =>
      checked ? [...prev, name] : prev.filter((n) => n !== name)
    );

  const selectAll = (checked: boolean) => {
    setSelected(
      checked ? subscribersColumns.map((i) => i.id) : uncheckableColumns
    );
    setSelectedCustomAttrs(checked ? customAttributeNames : []);
  };

  const allChecked =
    subscribersColumns.length === selected.length &&
    customAttributeNames.length === selectedCustomAttrs.length;

  return {
    apply,
    isSelected,
    selectColumn,
    allChecked,
    selectAll,
    isDisabled,
    isCustomAttrSelected,
    selectCustomAttr,
  };
}
